module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyBmb3IgeW91IHRvIHN0ZWFsIGFsbCB0aGUgZnVuZHMgZnJvbSB0aGUgY29udHJhY3QuCgombmJzcDsKVGhpbmdzIHRoYXQgbWlnaHQgaGVscDoKKiBVbnRydXN0ZWQgY29udHJhY3RzIGNhbiBleGVjdXRlIGNvZGUgd2hlcmUgeW91IGxlYXN0IGV4cGVjdCBpdC4KKiBGYWxsYmFjayBtZXRob2RzCiogVGhyb3cvcmV2ZXJ0IGJ1YmJsaW5nCiogU29tZXRpbWVzIHRoZSBiZXN0IHdheSB0byBhdHRhY2sgYSBjb250cmFjdCBpcyB3aXRoIGFub3RoZXIgY29udHJhY3QuCiogU2VlIHRoZSBIZWxwIHBhZ2UgYWJvdmUsIHNlY3Rpb24gIkJleW9uZCB0aGUgY29uc29sZSIK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/reentrancy.md
// module id = 1403
// module chunks = 0